// src/services/BinanceService.js
import BaseApi from "./BaseApi";

class MetricService extends BaseApi {
  constructor() {
    super("/metrics");
  }

  // API get metrics 
  getMetrics() {
    return this.get("");
  }               
  
  // API update metrics
  updateMetrics(coinList) {
    return this.post("", coinList);
  }
}

export default new MetricService();